module.exports = __webpack_public_path__ + "static/media/buffet12.8afa604c.jpg";